export const filterDomainName = (url: string): string => {
  if (url.endsWith("/")) {
    url = url.substring(0, url.length - 1);
  }
  // === Remove http:// || https:// from starts url ===
  if (url.startsWith("http://") || url.startsWith("https://")) {
    url = url.replace(/^https?:\/\//, "");
  }
  // === Remove :3030 from ends IP ===
  if (url.endsWith(":3030")) {
    url = url.replace(":3030", "");
  }

  return url;
};
